const SAVE_AUTH_USER = 'STEAM_SAVE_AUTH_USER'
const REMOVE_AUTH_USER = 'STEAM_REMOVE_AUTH_USER'
const STEAM_ACTIVATE_GAME_REQUEST = 'STEAM_ACTIVATE_GAME_REQUEST'
const STEAM_ACTIVATE_GAME_SUCCESS = 'STEAM_ACTIVATE_GAME_SUCCESS'
const STEAM_ACTIVATE_GAME_FAILURE = 'STEAM_ACTIVATE_GAME_FAILURE'
const STEAM_CHECK_AUTHENTICATE_SUCCESS = 'STEAM_CHECK_AUTHENTICATE_SUCCESS'
const STEAM_CHECK_AUTHENTICATE_FAILURE = 'STEAM_CHECK_AUTHENTICATE_FAILURE'
const SAVE_USER_TICKET_SUCCESS = 'STEAM_SAVE_USER_TICKET_SUCCESS'
const SAVE_USER_TICKET_FAILURE = 'STEAM_SAVE_USER_TICKET_FAILURE'
const USER_LOGIN_FAILURE = 'STEAM_USER_LOGIN_FAILURE'
const USER_LOGIN_REQUEST = 'STEAM_USER_LOGIN_REQUEST'
const USER_LOGIN_SUCCESS = 'STEAM_USER_LOGIN_SUCCESS'

export default {
  SAVE_AUTH_USER,
  REMOVE_AUTH_USER,
  STEAM_ACTIVATE_GAME_REQUEST,
  STEAM_ACTIVATE_GAME_SUCCESS,
  STEAM_ACTIVATE_GAME_FAILURE,
  STEAM_CHECK_AUTHENTICATE_SUCCESS,
  STEAM_CHECK_AUTHENTICATE_FAILURE,
  SAVE_USER_TICKET_FAILURE,
  SAVE_USER_TICKET_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
}
